<template>
  <v-menu
    v-model="isOpened"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <a v-on="on" class="text-no-wrap" v-if="!disabled">
        {{ item[fieldName] }}
      </a>
      <span v-else>
        {{ item[fieldName] }}
      </span>
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-form ref="editValueForm">
              <v-text-field
                :placeholder="$t('common.amount')"
                v-model="tmpItem[fieldName]"
                required
                type="numeric"
                :rules="[
                    (v) =>
                    isFloat(v, true) ||
                    isInt(v, true) ||
                    $t('form.validationErrors.must_be_float'),
                  (v) => !!v || $t('form.validationErrors.field_is_required'),
                  (v) => countDecimals(v.toString().replace(/,/g, '.'))<=3 || $t('form.validationErrors.too_much_number_of_decimals'),
                ]"
              ></v-text-field>
            </v-form>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="close">{{ $t("common.cancel") }} </v-btn>
        <v-btn color="primary" text @click="save()">
          {{ $t("common.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { isFloat, isInt, countDecimals } from "@/fn/math";
export default {
  name: "EditValueMenu",
  props: {
    disabled: false,
    item: null,
    fieldName: null,
  },
  data: () => ({
    isOpened: false,
    valueTmp: null,
    tmpItem: {},
  }),
  mounted() {
    this.tmpItem = { ...this.item };
  },
  watch: {
    isOpened(to) {
      if (to) {
        this.tmpItem = { ...this.item };
      }
    },
  },
  methods: {
    countDecimals,
    isInt,
    isFloat,
    close() {
      this.isOpened = false;
      this.tmpItem = { ...this.item };
    },
    save() {
      let isValid = this.$refs["editValueForm"].validate();
      if (!isValid) return;
      this.tmpItem[this.fieldName] = this.tmpItem[this.fieldName].replace(/,/g, '.')
      this.isOpened = false;
      this.$emit('update', this.tmpItem);
    },
  },
};
</script>

<style scoped></style>
